import React from "react";
import SvgIcon from "material-ui-next/SvgIcon";

export default props => (
  <SvgIcon viewBox="0 0 128 128" style={{ fill: "#3f8337" }} {...props}>
    <g id="Exel_download">
      <g>
        <g>
          <path d="M80.016,96h-8.297L63.75,83.039L55.781,96H48l11.367-17.672L48.727,61.734h8.016l7.383,12.328     l7.242-12.328h7.828L68.438,78.727L80.016,96z" />
        </g>
        <g>
          <g>
            <path d="M104,80c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S117.255,80,104,80z       M114.882,96.988l-0.113,0.176l-8.232,11.438C105.989,109.468,105.029,110,104,110s-1.989-0.532-2.536-1.397l-8.346-11.614      c-0.529-0.926-0.524-2.073,0.01-2.994c0.535-0.922,1.53-1.494,2.596-1.494H100V86c0-1.654,1.346-3,3-3h2c1.654,0,3,1.346,3,3      v6.5h4.276c1.065,0,2.061,0.572,2.596,1.494C115.406,94.915,115.411,96.063,114.882,96.988z" />
          </g>
          <g>
            <g>
              <polygon points="84,125.95 83.95,126 84,126" />
            </g>
            <g>
              <polygon points="114,77 114,76.95 113.95,77" />
            </g>
            <g>
              <path d="M111.071,44.243L71.757,4.929C69.869,3.041,67.357,2,64.687,2H24c-5.514,0-10,4.486-10,10v104       c0,5.514,4.486,10,10,10h59.95l-4-4H24c-3.309,0-6-2.691-6-6V12c0-3.309,2.691-6,6-6h40.687c1.603,0,3.109,0.624,4.242,1.757       l39.314,39.314c1.116,1.117,1.757,2.663,1.757,4.242V72.95l4,4V51.313C114,48.643,112.96,46.132,111.071,44.243z" />
            </g>
            <g>
              <polyline points="113.95,77 114,76.95 110,72.95" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);



// WEBPACK FOOTER //
// ./src/assets/icon/csv-file.jsx